// English — source of truth. All other locales must define exactly these keys.

export const en = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'How to Play',
  'howto.pieces.heading': 'The pieces',
  'howto.pieces.source': 'Source',
  'howto.pieces.mirror': 'Mirror',
  'howto.pieces.switch': 'Switch',
  'howto.pieces.exit': 'Exit',
  'howto.pieces.wall': 'Wall',
  'howto.controls.heading': 'The controls',
  'howto.controls.clickSlot.line1': 'Click slot',
  'howto.controls.clickSlot.line2': 'place mirror',
  'howto.controls.dragMirror.line1': 'Drag mirror',
  'howto.controls.dragMirror.line2': 'rotate',
  'howto.controls.rightClick.line1': 'Right-click',
  'howto.controls.rightClick.line2': 'remove mirror',
  'howto.controls.hint': 'Mouse wheel: fine rotate by 1°.   Tap mirror: rotate by 15°.',
  'howto.objective.line1': 'Light every switch — the exit lock springs open.',
  'howto.objective.line2': 'Then click the exit. Solve in as few mirrors as you can.',

  'howtoColor.title': 'Color & Prisms',
  'howtoColor.pieces.heading': 'New pieces',
  'howtoColor.pieces.prism': 'Prism',
  'howtoColor.pieces.redSwitch': 'Red switch',
  'howtoColor.pieces.yellowSwitch': 'Yellow switch',
  'howtoColor.pieces.whiteSwitch': 'White switch',
  'howtoColor.how.heading': 'How they work',
  'howtoColor.how.line1': 'A white beam carries red, green, and blue light at once.',
  'howtoColor.how.line2': 'A prism splits white into three colored beams along its three sides.',
  'howtoColor.how.line3': 'Click a placed prism to rotate where its input face points.',
  'howtoColor.switches.line1': "Switches show colored dots — that's the color they want.",
  'howtoColor.switches.line2': 'A yellow switch (red + green dots) needs both colors arriving.',
  'howtoColor.switches.line3': 'A white switch (all three) needs red, green, AND blue at once.',

  'options.hints.label': 'Show hint angles in puzzles',
  'options.hints.help':
    'Display the angle between the incoming and reflected beam at every bounce.',

  'level.01-intro.title': 'Hello Light',
  'level.02-two-mirrors.title': 'Two Turns',
  'level.03-corner.title': 'Wall in the Way',
  'level.04-two-targets.title': 'Two Targets',
  'level.05-tight.title': 'Tight',
  'level.06-hello-color.title': 'Hello Color',
  'level.07-pick-a-side.title': 'Pick a Side',
  'level.08-yellow.title': 'Yellow',
  'level.09-magenta.title': 'Magenta',
  'level.10-spectrum.title': 'Spectrum',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'right',
  'puzzle.hint.angleType.acute': 'acute',
  'puzzle.hint.angleType.obtuse': 'obtuse',
  'puzzle.hint.label': '{angle}°\n{type}',
} as const;
